
























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import PaymentMethodEdit from '@/components/PaymentMethod/PaymentMethodEdit.vue';

@Component({
  components: {
    PaymentMethodEdit,
  },
})
export default class PaymentMethodEditButton extends Vue {
  @Prop(String) private id!: string;
  private showDialog = false;

  @Emit()
  private paymentMethodUpdated() {
    this.showDialog = false;
  }
}
